import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

const STORAGE_KEY = 'blp_cookie_consent';

export function getConsent() {
  try {
    return window.localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);
  const panelRef = useRef(null);
  const previouslyFocused = useRef(null);

  useEffect(() => {
    if (!getConsent()) setVisible(true);
  }, []);

  useEffect(() => {
    if (!visible) return;
    previouslyFocused.current = document.activeElement;

    const node = panelRef.current;
    const focusable = node.querySelectorAll('a[href], button');
    if (focusable.length) focusable[0].focus();

    const onKeyDown = (e) => {
      if (e.key !== 'Tab' || focusable.length === 0) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    };

    node.addEventListener('keydown', onKeyDown);
    return () => node.removeEventListener('keydown', onKeyDown);
  }, [visible]);

  const handleChoice = (choice) => {
    try {
      window.localStorage.setItem(STORAGE_KEY, choice);
    } catch {
      /* storage unavailable — banner reappears next visit */
    }
    setVisible(false);
    window.dispatchEvent(new CustomEvent('cookie-consent-changed', { detail: choice }));
    if (previouslyFocused.current) previouslyFocused.current.focus();
  };

  if (!visible) return null;

  return (
    <div
      ref={panelRef}
      className="cookie-banner"
      role="dialog"
      aria-modal="false"
      aria-labelledby="cookie-banner-title"
    >
      <div className="cookie-banner-inner">
        <div className="cookie-banner-copy">
          <h2 id="cookie-banner-title" className="cookie-banner-title">Cookies on this site</h2>
          <p>
            We store a small amount of data in your browser so the site works and to
            remember this choice. With your consent we also measure how the site is
            used, so we can improve it.
          </p>
          <p>
            You can change your mind at any time. See our{' '}
            <Link to="/privacy-policy">privacy policy</Link> for details.
          </p>
        </div>
        <div className="cookie-banner-actions">
          <button type="button" className="cookie-btn" onClick={() => handleChoice('rejected')}>
            Reject non-essential
          </button>
          <button type="button" className="cookie-btn" onClick={() => handleChoice('accepted')}>
            Accept all
          </button>
        </div>
      </div>
    </div>
  );
}